import { Adapter } from '@mui/x-scheduler-internals/use-adapter';
import { ExtendableEventCalendarStore } from '@mui/x-scheduler-internals/use-event-calendar';
import { EventCalendarPremiumLazyLoadingPlugin } from './plugins/EventCalendarPremiumLazyLoadingPlugin';
import { schedulerRecurringEventsPlugin } from '../internals/plugins/schedulerRecurringEventsPlugin';
import { EventCalendarPremiumParameters } from './EventCalendarPremiumStore.types';

/**
 * Premium version of EventCalendarStore with premium plugins.
 */
export class EventCalendarPremiumStore<
  TEvent extends object,
  TResource extends object,
> extends ExtendableEventCalendarStore<TEvent, TResource> {
  public lazyLoading: EventCalendarPremiumLazyLoadingPlugin<TEvent>;

  public constructor(
    parameters: EventCalendarPremiumParameters<TEvent, TResource>,
    adapter: Adapter,
  ) {
    super(parameters, adapter, 'EventCalendarPremiumStore', schedulerRecurringEventsPlugin);

    this.lazyLoading = this.disposables.use(
      new EventCalendarPremiumLazyLoadingPlugin<TEvent>(this),
    );
  }

  public buildPublicAPI() {
    return {
      ...super.buildPublicAPI(),
    };
  }
}
